import React, {useEffect, useRef, useState} from 'react'
import ConfigUtil from "../../../../util/ConfigUtil";
import FetchUtil from "../../../../util/FetchUtil";
import {openEventOperatorById} from "../../../../containers/views/public/PublicTournamentHelper";

const MIN_SUCHLAENGE = 3;
// gesucht wird automatisch, kurz nachdem nicht mehr getippt wird
const VERZOEGERUNG_MS = 400;

/**
 * Suche nach Veranstaltern im neuen Design. Entspricht PublicEventoperatorSearchTab der alten Ansicht,
 * sucht aber ohne Knopf während der Eingabe und zeigt das Ergebnis als Tabelle im neuen Design.
 */
export default function VeranstalterSuche() {

    const [suche, setSuche] = useState("");
    const [veranstalter, setVeranstalter] = useState(undefined);
    const [working, setWorking] = useState(false);
    const [errorMessage, setErrorMessage] = useState(undefined);
    // nur die Antwort zum letzten Suchtext übernehmen
    const aktuelleSuche = useRef("");

    const text = suche.trim();
    const sucheAktiv = text.length >= MIN_SUCHLAENGE;

    useEffect(() => {
        aktuelleSuche.current = text;
        if (!sucheAktiv) {
            setVeranstalter(undefined);
            setWorking(false);
            return;
        }
        setWorking(true);
        const timer = setTimeout(() => {
            setErrorMessage(undefined);
            FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.public + "/eventoperators",
                {text: text},
                json => {
                    if (aktuelleSuche.current !== text) {
                        return;
                    }
                    setVeranstalter(json.eventOperators);
                    setWorking(false);
                },
                responseNotOk => {
                    if (aktuelleSuche.current === text) {
                        setErrorMessage("Die Suche ist fehlgeschlagen: " + responseNotOk.message);
                        setWorking(false);
                    }
                },
                error => {
                    if (aktuelleSuche.current === text) {
                        setErrorMessage("Die Suche ist fehlgeschlagen: " + error);
                        setWorking(false);
                    }
                });
        }, VERZOEGERUNG_MS);
        return () => clearTimeout(timer);
    }, [text]);

    const getStatus = () => {
        if (errorMessage) {
            return errorMessage;
        }
        if (!sucheAktiv) {
            return text.length === 0 ? "Gib den Namen deines Veranstalters ein, danach kannst du in seinen Bereich wechseln."
                : "Suche ab " + MIN_SUCHLAENGE + " Zeichen";
        }
        if (working || veranstalter === undefined) {
            return "Suche läuft …";
        }
        if (veranstalter.length === 0) {
            return "Keine Veranstalter zu „" + text + "“ gefunden.";
        }
        return veranstalter.length === 1 ? "1 Veranstalter gefunden" : veranstalter.length + " Veranstalter gefunden";
    }

    return <>
        <div className="dhpt-werkzeuge">
            <div className="dhpt-suche dhte-suche-links">
                <i className={working ? "pi pi-spin pi-spinner dhpt-suche-icon" : "pi pi-search dhpt-suche-icon"} aria-hidden="true"/>
                <input id="dhte-veranstalter-suche" type="search" className="dhpt-suche-feld" placeholder="Veranstalter suchen …"
                       aria-label="Veranstalter suchen" autoComplete="off" value={suche} onChange={(e) => setSuche(e.target.value)}/>
            </div>
        </div>
        <div className="dhpt-inhalt-eigen">
            <p className="dhpt-hinweis dhte-anzahl-text" aria-live="polite">{getStatus()}</p>
            {sucheAktiv && veranstalter !== undefined && veranstalter.length > 0 &&
                <div className="dhte-tabelle-rahmen">
                    <table className="dhte-tabelle dhte-veranstalter-tabelle">
                        <thead>
                        <tr>
                            <th scope="col">Veranstalter</th>
                        </tr>
                        </thead>
                        <tbody>
                        {veranstalter.map(eventOperator => <tr key={eventOperator.id} className="dhte-zeile"
                                                               onClick={() => openEventOperatorById(eventOperator.id)}>
                            <td>
                                <button type="button" className="dhte-titel" onClick={(event) => {
                                    event.stopPropagation();
                                    openEventOperatorById(eventOperator.id);
                                }}>
                                    <i className="pi pi-building dhte-veranstalter-icon" aria-hidden="true"/>
                                    {eventOperator.name}
                                </button>
                                <i className="pi pi-chevron-right dhte-veranstalter-pfeil" aria-hidden="true"/>
                            </td>
                        </tr>)}
                        </tbody>
                    </table>
                </div>
            }
        </div>
    </>
}
